import { toggleClass } from '@opten/dom/toggle-class';

export interface IMapExtendedOptions {
	zoom?: number;
	draggable?: boolean;
	urlLocation?: string;
	urlDatacenter?: string;
	animation?: google.maps.Animation;
	mapStyles?: any;
	styledMapName?: string;
	mapMarkerClasses?: string[];
	showMapMarkerClasses?: string[];
	hasMapMarkerClassesButtonIfMultiple?: boolean;
	mapMarkerClassesButtonActiveClass?: string;
	mapMarkerInfoClass?: string;
	mapTypes?: google.maps.MapTypeId[];
	mapTypeControlStyle?: google.maps.MapTypeControlStyle;
	fitToBounds?: boolean;
}

class MapMarkerExtended {
	public marker: google.maps.Marker;
	public className: string;
	public infoWindow: google.maps.InfoWindow;

	constructor(
		element: google.maps.Marker,
		className: string,
		infoWindow: google.maps.InfoWindow
	) {
		this.marker = element;
		this.className = className;
		this.infoWindow = infoWindow;
	}
}

export class MapExtended {
	private element: HTMLElement;
	private options: IMapExtendedOptions = {
		animation: google.maps.Animation.DROP,
		mapStyles: null,
		mapMarkerClasses: ['map-location'],
		showMapMarkerClasses: ['map-location'],
		hasMapMarkerClassesButtonIfMultiple: false,
		mapMarkerClassesButtonActiveClass: 'is-active',
		mapMarkerInfoClass: 'c-map-extended__information__marker',
		mapTypes: [
			google.maps.MapTypeId.ROADMAP,
			google.maps.MapTypeId.TERRAIN,
			google.maps.MapTypeId.SATELLITE,
			google.maps.MapTypeId.HYBRID
		],
		mapTypeControlStyle: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
		fitToBounds: true
	};

	private bounds: google.maps.LatLngBounds;
	private mapMarkers = Array<MapMarkerExtended>();
	map: google.maps.Map<HTMLElement>;

	constructor(element: HTMLElement, options: IMapExtendedOptions) {
		this.element = element;
		this.options = { ...this.options, ...options };
		this.init();

		if (
			this.options.hasMapMarkerClassesButtonIfMultiple &&
			this.options.mapMarkerClasses.length > 1
		) {
			this.options.mapMarkerClasses
				.map(markerClass => document.getElementById(markerClass))
				.filter(markerElement => markerElement != null)
				.forEach(markerElement =>
					markerElement.addEventListener('click', () =>
						this.showHideMapMarkerClass(markerElement)
					)
				);
		}
		var filterElements = document.querySelectorAll<HTMLElement>(
			'.js-map-extended-filter'
		);
		if (filterElements && filterElements.length > 1) {
			filterElements.forEach(markerElement =>
				markerElement.addEventListener('click', () =>
					this.showHideMapMarkerClass(markerElement, true)
				)
			);
			// var filterResetElements = document.querySelectorAll<HTMLElement>('.js-map-extended-filter-all');
			// if(filterResetElements && filterResetElements.length > 1){
			// 	filterResetElements.forEach(markerElement => markerElement.addEventListener('click', () => this.showHideMapMarkerClass(markerElement,false,true)));
			// }
		}
	}

	public init() {
		if (typeof google === 'object' && typeof google.maps === 'object') {
			var id = this.element.getAttribute('data-map-id');
			var zoom = this.element.getAttribute('data-zoom');
			var mapZoom;

			if (typeof zoom == 'undefined' || zoom == null) {
				mapZoom = this.options.zoom;
			} else {
				mapZoom = zoom;
			}

			//var lat;
			//var lng;
			this.bounds = new google.maps.LatLngBounds();

			var mapTypes: any = this.options.mapTypes;
			if (this.options.mapStyles != null) {
				mapTypes.push('map_style');
			}
			var mapOptions = {
				zoom: +mapZoom,
				draggable: true,
				mapTypeControlOptions: {
					mapTypeIds: mapTypes,
					style: this.options.mapTypeControlStyle
				}
			};

			this.map = new google.maps.Map(
				document.getElementById(id),
				mapOptions
			);

			if (this.options.mapStyles != null) {
				var nameMap =
					this.options.styledMapName != null
						? this.options.styledMapName
						: 'Map';
				var styledMap = new google.maps.StyledMapType(
					this.options.mapStyles,
					{ name: nameMap }
				);

				this.map.mapTypes.set('map_style', <any>styledMap);
				this.map.setMapTypeId(<any>'map_style');
			}

			if (this.options.mapMarkerClasses.length > 0) {
				this.options.mapMarkerClasses.forEach(markerClass => {
					var markersClass = this.element.querySelectorAll(
						'.' + markerClass
					);
					if (markersClass.length > 0) {
						var showMarker =
							this.options.showMapMarkerClasses.indexOf(
								markerClass
							) > -1;
						markersClass.forEach(markerClassInfo =>
							this.createMarkerClass(
								markerClassInfo,
								markerClass,
								this.map,
								showMarker
							)
						);
					}
				});
			}

			if (this.options.fitToBounds) {
				this.map.fitBounds(this.bounds);
				this.optimizeBounds();
			} else if (mapZoom != null && mapZoom > 0) {
				google.maps.event.addListenerOnce(this.map, 'idle', () => {
					this.map.setZoom(+mapZoom);
				});
			}
		} else {
			console.error('Google Maps API is not included');
		}
	}
	optimizeBounds() {
		if (this.options.zoom) {
			google.maps.event.addListenerOnce(this.map, 'idle', () => {
				const zoom = this.map.getZoom();
				if (zoom > this.options.zoom) {
					this.map.setZoom(+this.options.zoom);
				}
			});
		}
	}

	private createMarkerClass(
		markerClassInfo: Element,
		markerClass: string,
		map: google.maps.Map,
		showMarker: boolean
	) {
		var markerInfoData = markerClassInfo as HTMLElement;
		const dataCoordinates = markerInfoData.getAttribute('data-coordinates');
		const latlng = dataCoordinates.replace(' ', '').split(',');
		var dataLat = latlng[0];
		var dataLng = latlng[1];
		var mapMarkerIcon = markerInfoData.getAttribute('data-marker');
		var mapMarkerWidth = markerInfoData.getAttribute('data-marker-width');
		var mapMarkerHeight = markerInfoData.getAttribute('data-marker-height');
		var mapMarkerOriginX = markerInfoData.getAttribute(
			'data-marker-origin-x'
		);
		var mapMarkerOriginY = markerInfoData.getAttribute(
			'data-marker-origin-y'
		);
		var mapMarkerAnchorX = markerInfoData.getAttribute(
			'data-marker-anchor-x'
		);
		var mapMarkerAnchorY = markerInfoData.getAttribute(
			'data-marker-anchor-y'
		);

		var mapMarkerInfoArray = markerInfoData.querySelectorAll(
			'.' + this.options.mapMarkerInfoClass
		);
		var mapMarkerInfo = '';
		if (mapMarkerInfoArray.length > 0) {
			mapMarkerInfo = markerInfoData.innerHTML;
		}

		this.createMarker(
			dataLat,
			dataLng,
			mapMarkerIcon,
			mapMarkerWidth,
			mapMarkerHeight,
			mapMarkerOriginX,
			mapMarkerOriginY,
			mapMarkerAnchorX,
			mapMarkerAnchorY,
			mapMarkerInfo,
			map,
			showMarker,
			markerClass
		);
	}

	private createMarker(
		lat,
		lng,
		mapMarkerIcon,
		mapMarkerWidth,
		mapMarkerHeight,
		mapMarkerOriginX,
		mapMarkerOriginY,
		mapMarkerAnchorX,
		mapMarkerAnchorY,
		mapMarkerInfo,
		map,
		showMarker,
		markerClass
	) {
		var marker = new google.maps.Marker({
			position: new google.maps.LatLng(+lat, +lng),
			map: map,
			icon: {
				size: new google.maps.Size(+mapMarkerWidth, +mapMarkerHeight),
				origin: new google.maps.Point(
					+mapMarkerOriginX,
					+mapMarkerOriginY
				),
				anchor: new google.maps.Point(
					+mapMarkerAnchorX,
					+mapMarkerAnchorY
				),
				url: mapMarkerIcon
			},
			visible: showMarker
		});

		this.bounds.extend(marker.getPosition());
		var infoWindow = null;
		if (mapMarkerInfo != '') {
			infoWindow = new google.maps.InfoWindow({
				content: mapMarkerInfo
			});

			marker.addListener('click', function () {
				infoWindow.open(map, marker);
			});
		}

		this.mapMarkers.push(
			new MapMarkerExtended(marker, markerClass, infoWindow)
		);
	}

	private showHideMapMarkerClass(
		button: HTMLElement,
		isListFilter: boolean = false,
		isResetListFilter: boolean = false
	) {
		if (isListFilter == false && isResetListFilter == false) {
			var className = button.id;
			toggleClass(button, this.options.mapMarkerClassesButtonActiveClass);
			var visible = button.classList.contains(
				this.options.mapMarkerClassesButtonActiveClass
			); // show if checked, otherwise hide
			if (className.length != null && className.length > 0) {
				this.mapMarkers
					.filter(mapMarker => mapMarker.className === className)
					.forEach(mapMarker => mapMarker.marker.setVisible(visible));
			}
		} else if (isListFilter) {
			var filter = button.getAttribute('data-filter');
			if (filter != undefined) {
				if (filter.indexOf('all') > -1) {
					this.showAllMapMarkers();
				} else {
					var className = filter.replace('.', '');
					this.mapMarkers
						.filter(mapMarker => mapMarker.className === className)
						.forEach(mapMarker =>
							mapMarker.marker.setVisible(true)
						);
					this.mapMarkers
						.filter(mapMarker => mapMarker.className !== className)
						.forEach(mapMarker => {
							mapMarker.marker.setVisible(false);
							if (mapMarker.infoWindow != null) {
								mapMarker.infoWindow.close();
							}
						});
					this.reinitBoundsToVisibleMarkers();
				}
			}
		} else if (isResetListFilter) {
			this.showAllMapMarkers();
		}
	}

	private showAllMapMarkers() {
		this.mapMarkers.forEach(mapMarker => mapMarker.marker.setVisible(true));
		this.reinitBoundsToVisibleMarkers();
	}

	private reinitBoundsToVisibleMarkers() {
		this.bounds = new google.maps.LatLngBounds();
		this.mapMarkers
			.filter(o => o.marker.getVisible())
			.forEach(o => this.bounds.extend(o.marker.getPosition()));
		this.map.fitBounds(this.bounds);
		this.optimizeBounds();
	}
}
